import {
  adjustTimetableWeek,
  adjustTimetableDay,
} from '@versita/frontend/timetable-state';
import { Student } from '@versita/shared/models';
import { prop, __ } from 'ramda';

/**
 * Returns a function to adjust the timetable period
 * based on the view mode.
 */
export const useAdjustTimetablePeriod = prop(__, {
  WEEK: adjustTimetableWeek,
  DAY: adjustTimetableDay,
} as const);
